import paths from "@ingka/icons-shared/paths/information-circle";
import { renderPaths } from "../renderPaths.mjs";
var information_circle_default = () => renderPaths(paths);
export {
  information_circle_default as default
};
